<template>
  <div id="card-price">
    <vx-card class="mb-base card bg-black items-center">
      <div class="vx-row card-container mx-1">
        <h5 class="white">{{title}}</h5>
        <div class="vx-col mt-2">
          <h2 class="success bold">{{ formatNumber(value) }} {{ $t("Liter") }} </h2>
        </div>
      </div>
    </vx-card>
  </div>
</template>
<script>
import { formatNumber } from "@/utils/index";

export default {
  name: "cardPrice",
  data() {
    return {
      formatNumber
    }
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: "Total"
    }
  }
};
</script>
<style scoped>
.card-container {
  justify-content: space-between;
}
.card {
  width: 210px;
}
</style>